import { getUserType } from "../../storage/storage";
import { useGetAllModuleAccessQuery } from "../../store/api/rolesandpermission";

const RolesandPermission = ({ modulename, type, children }) => {

  const { data: permissions } = useGetAllModuleAccessQuery();

  const userType = getUserType();

  const isModuleAllowed = () => {
    if(userType === "Super Admin login" || userType === "GYM_ADMIN login") return true;
    if (!permissions || !permissions.data) return false;


    const modulePermission = permissions.data[`${modulename}_api`];

    if (modulePermission === "Full") {
      return true;
    } else if (modulePermission === "Partially") {
      if (type) {
        const partialAccess = permissions.partialy_acces || [];

        return partialAccess.some(
          (access) =>
            access.module === `${modulename}_api` && access.type === type
        );
      }
      return false;
    }
    return false;
  };

  return isModuleAllowed() ? children : null;
};

export default RolesandPermission;
